import React from 'react';
import { FaChevronDown, FaTimes, FaSearch } from 'react-icons/fa';

function ProductsDropdown({ onClose }) {
  return (
    <div className="products-dropdown">
      <div className="dropdown-header">
        <h3>Products</h3>
        <div className="show-products-toggle">
           Show products for all projects <input type="checkbox" />
        </div>
        <FaTimes className="close-icon" onClick={onClose} />
      </div>
      <div className="dropdown-content">
         <div className="product-items-grid">
           <div className="product-item">
              <div className="product-icon"><FaSearch /></div>
              <div className="product-name">Go to Homepage</div>
           </div>
            <div className="product-item">
              <div className="product-icon" style={{ backgroundColor: '#3b5998' }}></div> {/* Placeholder for blue circle */}
              <div className="product-name">Hootsuite</div>
           </div>
         </div>
         <div className="footer-link">
            Go to Homepage
         </div>
      </div>
    </div>
  );
}

export default ProductsDropdown; 